export default __webpack_public_path__ + "static/media/9.0981d303.jpeg";